import sample from 'lodash/sample'
export default function (_req, res, _next) {
  res.setHeader('Content-Type', 'text/plain; charset=utf-8')
  const statusCode = sample([200, 503])
  res.statusCode = statusCode
  res.end(statusCode !== 200 ? 'failed' : 'ok')
}
